import { useState, useEffect } from 'react';

const useQuery = <T,>(queryFn: () => Promise<T>) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isPending, setIsPending] = useState<boolean>(true);
  const [complete, setComplete] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true; // Prevent state updates on unmounted components

    const fetchData = async () => {
      setIsPending(true);
      setError(null);
      setComplete(false);

      try {
        const result = await queryFn();
        if (isMounted) {
          setData(result);
          setComplete(true);
        }
      } catch (err) {
        if (isMounted) setError(err as Error);
      } finally {
        if (isMounted) setIsPending(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup on component unmount
    };
  }, [queryFn]);

  return { data, error, isPending, complete };
};

export default useQuery;
